export enum CargoOperationTypeEnum {
    Loading = 0,
    Unloading = 1,
}
